import { _ } from './utils'
import OriginalListing from './modules/original-listing'
import SearchModal from './modules/search-modal'

_('original-listing')
    .nodes()
    .map((el) => new OriginalListing(el))

const siteSearchModal = document.querySelector('[data-element="site-search"].site-search')
if (siteSearchModal) {
    new SearchModal(siteSearchModal)
}
